export default __webpack_public_path__ + "static/media/image-chairsensor-w@2x.a14aac2e.webp";